import { createFileRoute } from '@tanstack/react-router';
import { OrderPage } from '@/features/orders/components/OrderPage';

export const Route = createFileRoute('/$commiteeSlug/orders/$orderId')({
  component: OrderPage,
});
